import React, {useEffect, useRef, useState} from 'react'
import {useField} from 'formik'
import {Collapse} from 'react-bootstrap'
import {TComponentTotpConnect} from './_types'
import ComponentButton from '../ComponentButton'
import {QRCodeSVG} from 'qrcode.react'
import {useAuth} from '../../../modules/auth'

const ComponentTotpConnect: React.FC<TComponentTotpConnect> = ({
    article,
    uri,
    code = '',
    is_disabled,
}) => {
    const [field] = useField<any>(article)
    const [open, setOpen] = useState(false)
    const containerRef = useRef<HTMLDivElement | null>(null)
    const user = useAuth()

    const totpIsConnect = user?.currentUser?.oauth_type === 'totp' ? 'Подключено' : 'Подключить'

    const copy = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text)
        } catch {}
    }

    useEffect(() => {
        if (open && containerRef.current) {
            containerRef.current.scrollIntoView({behavior: 'smooth', block: 'nearest'})
        }
    }, [open])

    return (
        <div className='componentTotpConnect' ref={containerRef}>
            <ComponentButton
                type='custom'
                settings={{
                    icon: 'shield-check',
                    title: `${open ? 'Закрыть' : totpIsConnect}`,
                    background: 'dark',
                }}
                customHandler={() => setOpen((v) => !v)}
                disabled={is_disabled}
            />

            <Collapse in={open}>
                <div id={`totp-panel-${article}`} className='mt-4'>
                    <div className='card shadow-sm border'>
                        <div className='card-body d-flex flex-column align-items-center gap-4'>
                            <span>
                                Подключите приложение-аутентификатор (Google Authenticator, Authy и
                                т.п.).
                                <br />
                                1. Отсканируйте QR-код или введите код вручную.
                                <br />
                                2. В приложении появится шестизначный одноразовый пароль.
                                <br />
                                3. Используйте этот пароль при входе в систему.
                            </span>

                            <QRCodeSVG value={uri} size={240} level='M' />

                            {/* URI */}
                            <div className='w-100'>
                                <label className='form-label fw-bold mb-1'>URI (otpauth)</label>
                                <div className='d-flex gap-2'>
                                    <input className='form-control' readOnly value={uri ?? ''} />
                                    <ComponentButton
                                        type='custom'
                                        settings={{icon: 'copy', title: '', background: 'dark'}}
                                        customHandler={() => (uri ? copy(uri) : undefined)}
                                    />
                                </div>
                            </div>

                            {/* Секрет */}
                            {code ? (
                                <div className='w-100'>
                                    <label className='form-label fw-bold mb-1'>Код (секрет)</label>
                                    <div className='d-flex gap-2'>
                                        <input className='form-control' readOnly value={code} />
                                        <ComponentButton
                                            type='custom'
                                            settings={{icon: 'copy', title: '', background: 'dark'}}
                                            customHandler={() => copy(code)}
                                        />
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </Collapse>

            <input
                type='hidden'
                name={field.name}
                value={JSON.stringify(field.value ?? {uri, code})}
                readOnly
            />
        </div>
    )
}

export default ComponentTotpConnect
